import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
import contactUsAfterSubmit from '../../../../../assets/contactUsAfterSubmit.svg';
export const afterSubmitDialog = (t, data) => {
    if (data.selectRecipient) {
        const title = (React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 2 },
            React.createElement("img", { style: { width: '100%' }, src: contactUsAfterSubmit, alt: t('contactUs.afterSubmitDialog.illustrationAlt') }),
            React.createElement(Typography, { variant: 'h6', color: themeColors.text.main }, t('contactUs.afterSubmitDialog.title'))));
        const contentText = data.selectRecipient === 'org-admin'
            ? t('contactUs.afterSubmitDialog.contentOrgAdmin')
            : t('contactUs.afterSubmitDialog.contentClientAdmin');
        const content = (React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle }, contentText));
        showAlertDialog({ title, content });
    }
};
